import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function K() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    const items = new Array(12).fill(1);

    return (
        <div className={`sp-175w-K sp-175w-common ${css['sp-175w-K']}`}>
            <div className="info center">
                <p className="title">{t('K_title')}</p>
            </div>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className="item" key={k}>
                        <p className="item-title">{t(`K_item${k + 1}_title`)}</p>
                        <p className="item-desc">{t(`K_item${k + 1}_desc`)}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
